import * as S from "../dashboard/_shared";
import "./style.scss";

export default function CardJourneyBar({ dist, tipo, small }) {
  const { CES_COLS, CSAT_COLS } = S;

  if (!dist) return null;

  const cols = tipo === "ces" ? CES_COLS : CSAT_COLS;

  const topLabel =
    tipo === "ces"
      ? "Ext.Fácil + Fácil = Top2Box%"
      : "Satisfeito + Muito Satisfeito = CSAT%";

  return (
    <div className="compCardJourneyBar">
      <div className={`bar-track${small ? " small" : ""}`}>
        {cols.map((c) => (
          <div
            key={c.k}
            className="bar-segment"
            title={`${c.l}: ${dist[c.k]}%`}
            style={{
              "--_seg-width": `${dist[c.k] || 0}%`,
              "--_seg-color": c.c,
            }}
          />
        ))}
      </div>
      {!small && (
        <>
          <div className="legend">
            {cols.map((c) => (
              <div
                key={c.k}
                className="legend-item"
              >
                <div
                  className="legend-dot"
                  style={{ "--_seg-color": c.c }}
                />
                {c.l} <b>{dist[c.k] || 0}%</b>
              </div>
            ))}
          </div>
          <div className="top-label">{topLabel}</div>
        </>
      )}
    </div>
  );
}
